module.exports = __webpack_public_path__ + "static/media/9DESA22.c4f779b7.jpg";